





























import {
  Component,
  Prop,
  Vue,
} from "@/shared/vuepack";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import {
  HsaBankSsoLocationParameter,
  HsabSsoDestination,
  HsabSsoDestinationParameters
} from "@/shared/types";

@Component({
  components: { SsoDeepLink }
})
export default class ClaimNumberSsoDeepLink extends Vue {
  flagStore = useFeatureFlagStore();
  ssoAccountClaimDestinations = HsabSsoDestination;

  @Prop({ required: true })
  claimNumber: string;

  @Prop({ required: true })
  showAsButton: boolean;

  get showClaimSsoLinkWithParam () {
    return this.flagStore.flags.bend18282ClaimSsoLinkWithParam &&
        !this.flagStore.flags.bend18282ClaimSsoLinkDashboard;
  }

  get showClaimSsoLinkDashboard () {
    return (this.flagStore.flags.bend18282ClaimSsoLinkDashboard ||
        (this.flagStore.flags.bend18282ClaimSsoLinkDashboard && this.flagStore.flags.bend18282ClaimSsoLinkWithParam));
  }

  get showPlainTextClaimNumber () {
    return this.hasClaimNumber
        && !this.flagStore.flags.bend18282ClaimSsoLinkWithParam
        && !this.flagStore.flags.bend18282ClaimSsoLinkDashboard
        && !this.showAsButton;
  }

  get hasClaimNumber () {
    return this.claimNumber !== undefined
        && this.claimNumber !== null
        && this.claimNumber !== "";
  }

  get claimSsoLinkParameters (): HsaBankSsoLocationParameter[] {
    if (!this.hasClaimNumber) {
      return [];
    }

    return [
      {
        parameter: HsabSsoDestinationParameters.ClaimNumber,
        value: this.claimNumberWithoutFirstThreeChars
      }
    ];
  }

  get claimNumberWithoutFirstThreeChars (): string {
    return this.claimNumber.slice(3);
  }
}
